<template>
  <pui-popper
    ref="popper"
    :customReference="reference"
    :trigger="Trigger.CLICK_TO_OPEN"
    @open="onOpened"
    @close="onClosed"
    @documentClick="onDocumentClick"
    constrainWidth
    class="file-search-filters__root"
    popperClass="file-search-filters__popper"
  >
    <template #default>
      <slot></slot>
    </template>
  </pui-popper>
</template>

<script>
import { Trigger } from 'piivo-ui/src/components/popper/Popper';

export default {
  props: {
    /**
     * Custom element to position the popper from
     *
     * @type {Object}
     * @default null
     */
    reference: {
      type: null, // Any type
      default: null,
      validator: value =>
        value && value.getBoundingClientRect && typeof value.getBoundingClientRect === 'function',
    },
  },
  data() {
    return {
      // POPPER
      Trigger,
    };
  },
  computed: {
    /**
     * @returns {object} class object for the main container
     */
    mainClass() {
      return {
        'file-search-filters__popper-content file-search-filters__main': true,
        loading: this.loading,
      };
    },
  },
  methods: {
    // POPPER
    /**
     * Re emits the 'open' event
     *
     * @returns {void}
     */
    onOpened() {
      this.$emit('opened');
    },
    /**
     * Re emits the 'close' event
     *
     * @returns {void}
     */
    onClosed() {
      this.$emit('closed');
    },
    /**
     * Closes the popper when the popper is open and it detects
     * a click outside
     *
     * @returns {void}
     */
    onDocumentClick() {
      // Do not emit the 'close' event, since we manually close
      // the popper. The popper closing will emit the 'close' event
      // that we already re emit
      this.close();
    },
    /**
     * Closes the popper
     *
     * @returns {void}
     */
    close() {
      if (this.$refs.popper) {
        this.$refs.popper.close();
      }
    },
    /**
     * Updates the popper
     *
     * @returns {void}
     */
    // eslint-disable-next-line @typescript-eslint/require-await
    async updatePopper() {
      if (this.$refs.popper) {
        return this.$refs.popper.update();
      }

      return null;
    },
  },
};
</script>
